import styled from 'styled-components'
import { font, greys } from 'assets/themes/theme-default'

const TitleItem = styled.h5`
  color: ${greys.dark1};
  font-weight: ${font.weight.base};
  font-size: ${font.size.sm};
  line-height: ${font.size.lg};
  position: relative;
  padding: 0 0 0 10px;
  margin: 0 0 10px 0;
  :before {
    position: absolute;
    left: -0px;
    top: 2px;
    content: '';
    height: 12px;
    width: 4px;
    display: inline-block;
    margin: 0 6px 0 0;
    background-color: ${props => props.theme.colors.color1.bg};
  }
`

export default TitleItem
